
import { defineComponent, PropType } from 'vue'
import { Check, Run, RunReportStatus, ScaCheck } from '~/types/types'
import { getPackageManagerIcon } from '~/utils/dependencies'
import { extractHashId } from '~/utils/hashId'
import { shortenLargeNumber } from '~/utils/string'

export default defineComponent({
  name: 'CheckSwitcherMobile',

  props: {
    run: {
      type: Object as PropType<Run>,
      required: true
    },
    checks: {
      type: Array as PropType<Check[]>,
      required: true
    },
    scaChecks: {
      type: Array as PropType<ScaCheck[]>,
      default: () => []
    },
    reportCardRoute: {
      type: String,
      required: true
    }
  },

  computed: {
    hasReportCard(): boolean {
      return Boolean(this.run.reportCard) && !this.run.isForDefaultBranch
    },
    isReportCardReady(): boolean {
      return this.run.reportCard?.status === RunReportStatus.Completed
    },
    isReportCardSkipped(): boolean {
      return this.run.reportCard?.status === RunReportStatus.Skipped
    },
    isReportCardActive(): boolean {
      return this.$route.name === 'provider-owner-repo-run-runId' && this.hasReportCard
    },
    currentSelection(): string {
      if (this.isReportCardActive) return 'Report Card'
      const activeCheck = this.checks.find((c) => this.isCheckActive(c))
      if (activeCheck) return activeCheck.analyzer?.name ?? 'All checks'
      const activeSca = this.scaChecks.find((s) => this.isScaCheckActive(s))
      if (activeSca) return this.scaCheckLabel(activeSca)
      return 'All checks'
    }
  },

  methods: {
    shortenLargeNumber,
    getPackageManagerIcon,
    getCheckRoute(check: Check): string {
      const { runId } = this.$route.params
      return check.analyzer ? this.$generateRoute(['run', runId, check.analyzer.shortcode]) : ''
    },
    getScaCheckRoute(scaCheck: ScaCheck): string {
      if (!scaCheck.target?.id) return ''
      const { runId } = this.$route.params
      return this.$generateRoute(['run', runId, 'sca', extractHashId(scaCheck.target.id)])
    },
    isCheckActive(check: Check): boolean {
      return this.$route.params.analyzer === check.analyzer?.shortcode
    },
    isScaCheckActive(scaCheck: ScaCheck): boolean {
      return Boolean(
        this.$route.name?.includes('sca') &&
        this.$route.params.targetId &&
        scaCheck.target?.id &&
        this.$route.params.targetId === extractHashId(scaCheck.target.id)
      )
    },
    scaCheckLabel(scaCheck: ScaCheck): string {
      const manifest = scaCheck.target?.manifestPath || ''
      const lockfile = scaCheck.target?.lockfilePath || ''
      if (manifest && lockfile) return `${manifest}/${lockfile}`
      if (manifest || lockfile) return manifest || lockfile
      return 'SCA target'
    }
  }
})
